/**
 * The six digits we email, as people actually enter them: pasted with a space on
 * either side, or copied in two halves. Only the digits are kept, six at most, so
 * the field holds what was sent.
 *
 * The inputs carry no maxlength on purpose. The browser trims a paste to fit before
 * any script sees it, so " 587320" would arrive as " 58732" and be refused for a
 * digit nobody typed wrong.
 *
 * Delegated from the document because most of these fields are revealed after the
 * page loads. Binding it twice is harmless: the second pass finds nothing to strip.
 */
export function keepCodeDigits() {
    $(document).on('input', '[data-code-field]', (event) => {
        const field = event.currentTarget;
        const digits = field.value.replace(/\D/g, '').slice(0, 6);

        if (field.value !== digits) {
            field.value = digits;
        }
    });
}
